import { Value } from 'slate';
import resumeDefaultData from './resumeDefaultValues';

export default ({ selectedPlan = null, universityPlan = null }) => {
  const resumeDefaultValues = resumeDefaultData({
    selectedPlan,
    universityPlan,
  });
  return {
    templateType: 'RESUME',
    resumeType: 'Attractive',
    formatType: 'Resume',
    documentName: 'Beautiful Template',
    editedInputs: resumeDefaultValues.editedInputs,
    linkedInOptimizerEditedInputs:
      resumeDefaultValues.linkedInOptimizerEditedInputs,
    questionsGeneratorEditedInputs:
      resumeDefaultValues.questionsGeneratorEditedInputs,
    eventTypes: resumeDefaultValues.eventTypes,
    removeOnNextLoad: resumeDefaultValues.removeOnNextLoad,
    userPreferences: resumeDefaultValues.userPreferences,
    fullName: Value.fromJSON(resumeDefaultValues.fullName),
    tagline: Value.fromJSON(resumeDefaultValues.tagline),
    phoneNumber: Value.fromJSON(resumeDefaultValues.phoneNumber),
    address: Value.fromJSON(resumeDefaultValues.address),
    email: Value.fromJSON(resumeDefaultValues.email),
    personalLinks: Value.fromJSON(resumeDefaultValues.personalLinks),
    objective: Value.fromJSON(resumeDefaultValues.objective),
    workExperience: Value.fromJSON(resumeDefaultValues.workExperience),
    education: Value.fromJSON(resumeDefaultValues.education),
    skills: Value.fromJSON(resumeDefaultValues.skills),
    awardsAndHonors: Value.fromJSON(resumeDefaultValues.awardsAndHonors),
    volunteerWork: Value.fromJSON(resumeDefaultValues.volunteerWork),
    certifications: Value.fromJSON(resumeDefaultValues.certifications),
    projects: Value.fromJSON(resumeDefaultValues.projects),
    researchExperience: Value.fromJSON(resumeDefaultValues.researchExperience),
    summary: Value.fromJSON(resumeDefaultValues.summary),
    leadership: Value.fromJSON(resumeDefaultValues.leadership),
    associations: Value.fromJSON(resumeDefaultValues.associations),
    extraCurricular: Value.fromJSON(resumeDefaultValues.extraCurricular),
    languages: Value.fromJSON(resumeDefaultValues.languages),
    hobbiesAndInterests: Value.fromJSON(
      resumeDefaultValues.hobbiesAndInterests,
    ),
    courses: Value.fromJSON(resumeDefaultValues.courses),
    conferences: Value.fromJSON(resumeDefaultValues.conferences),
    references: Value.fromJSON(resumeDefaultValues.references),
    patents: Value.fromJSON(resumeDefaultValues.patents),
    testScores: Value.fromJSON(resumeDefaultValues.testScores),
    publications: Value.fromJSON(resumeDefaultValues.publications),
    importFileData: '',
    collapse: {
      document: null,
    },
    marks: {
      underline: false,
      bold: false,
      italic: false,
    },
    // For Tests****
    history: {
      tail: {
        next: null,
        prev: null,
      },
    },
  };
};
